import {createTheme} from 'baseui';
import type {Theme} from 'baseui';
import {Colors} from 'baseui/styles';

const primitives = {
  primaryFontFamily: 'Orca',
};

const overrides = {
  typography: {
    DisplayLarge: {
      fontFamily: 'Orca',
    },
    DisplayMedium: {
      fontFamily: 'Orca',
    },
    DisplaySmall: {
      fontFamily: 'Orca',
    },
    DisplayXSmall: {
      fontFamily: 'Orca',
    },
  },
  breakpoints: {
    small: 0,
    medium: 760,
    large: 980,
    extraLarge: 1200,
  },
  mediaQuery: {
    small: '@media screen and (max-width: 760px)',
    medium: '@media screen and (min-width: 761px) and (max-width: 980px)',
    large: '@media screen and (min-width: 981px)',
    extraLarge: '@media screen and (min-width: 1201px)',
  },
  colors: {
    backgroundPrimary: '#FFF',
    backgroundSecondary: '#f5f5f5',
    backgroundTertiary: '#f7f7f7',
    backgroundAlwaysDark: '#33343D',
    backgroundAccent: '#0E151F',
    backgroundPositive: '#EFEFEF',
    backgroundLightAccent: '#E5E5E5',
    backgroundLightPositive: '#111C2D',
    backgroundOverlayLight: '#CDD0D4',
    backgroundAlwaysLight: '#EFEFEF66',
    backgroundLightNegative: '#F7F7F7',
    primary200: '#12151A',
    primary300: '#F2F2F2',
    primary600: '#606060',
    primary500: '#DADADA',
    accent100: '#427ce7',
  } as Partial<Colors>,
} as const;

interface DerivedColors extends Colors {
  backgroundPrimary: string;
  backgroundAlwaysDark: string;
  backgroundAccent: string;
  backgroundPositive: string;
  backgroundLightAccent: string;
  backgroundLightPositive: string;
  backgroundOverlayLight?: string;
  backgroundAlwaysLight: string;
  backgroundSecondary: string;
  backgroundTertiary: string;
  primary200: string;
  primary300: string;
  primary600: string;
  primary500: string;
}

export type ThemeExtension = {
  colors: DerivedColors;
};

type CustomTheme = Theme & ThemeExtension;

const theme: CustomTheme = createTheme(primitives, overrides);

export default theme;
